import React, { useState } from 'react'
import { withRouter } from 'react-router-dom';
import IconClose from 'assets/icons/icon-close.svg'
import { Modal, Button } from 'antd'
import IconDevice from 'assets/images/payment/package-01.svg'
import IconStat from 'assets/images/payment/package-02.svg'
import styles from './ModalStartTrial.module.scss'
import { TranslateLanguage } from 'util/Translate'
import { vocabModalStartTrial } from 'util/Translate.variable'

const translate = new TranslateLanguage()
translate.addMaping(vocabModalStartTrial)


const ModalStartTrial = ({
  visible,
  handleCancel,
  history
}) => {
  const [isLoading] = useState(false)
  return (
    <div>
      <Modal
        visible={visible}
        footer={null}
        onCancel={handleCancel}
        width={540}
        closeIcon={<img alt='IconClose' src={IconClose} />}
      >
        <div className={styles.rootModal}>
          <h1>{translate.convert('ทำข้อสอบได้ไม่อั้น')}  {translate.convert('ทุกที่')} {translate.convert('ทุกเวลา')} </h1>
          <div className={styles.detail}>
            {translate.convert('ทดลองใช้งานฟรี 14 วัน')} <br />
          </div>
          <div className={styles.description}>
            {translate.convert('ไม่เก็บค่าบริการ')} {translate.convert('จนกว่าจะหมดระยะเวลาทดลองใช้')}
          </div>
          <div className={styles.content}>
            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', width: '50%' }}>
              <div className={styles.circle}>
                <img alt='IconDevice' src={IconDevice} />
              </div>
              <div className={styles.txtLabel}>
                {translate.convert('ใช้งานได้ทุก')} {translate.convert('Device')}
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', width: '50%' }}>
              <div className={styles.circleTwo}>
                <img alt='IconStat' src={IconStat} />
              </div>
              <div className={styles.txtLabel}>
                {translate.convert('เก็บสถิติติดตามผลสอบ')}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.txtSubLabel}>
          {translate.convert('ไม่มีสัญญาผูกมัด')} {translate.convert('สามารถยกเลิกได้เมื่อต้องการ')}
        </div>
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Button button-itemid='goToPackage' style={{ width: 350, height: 48 }} type='primary' loading={isLoading} onClick={() => {
            history.push('/package')
          }}>{translate.convert('เริ่มทดลองใช้งาน')}</Button>
        </div>
      </Modal>
    </div>
  )
}
export default withRouter(ModalStartTrial)